import type { ApproBffSDK } from '@invivodf/module-appro-bff-sdk'
import { accessTokenSource } from '@b2ag/axios-client'
import { buildCallerId } from '@b2ag/utils/src/caller-id'
import { sdk as createBffSdk } from '@invivodf/module-appro-bff-sdk/dist/bff.sdk'
import type { SearchDynamicSegmentsParameters } from '@invivodf/module-appro-bff-sdk/dist/entrypoints/segments/search-dynamic-segments/search-dynamic-segments'

export type SegmentsServiceParams = { segmentsApiHost: string }

class SegmentsService {
  private readonly sdk: ApproBffSDK

  constructor({ segmentsApiHost }: SegmentsServiceParams) {
    this.sdk = createBffSdk(segmentsApiHost, { callerId: buildCallerId(), accessTokenSource })
  }

  fetchDynamicSegments({ partnerId, customerCode, requests }: SearchDynamicSegmentsParameters) {
    return this.sdk.searchDynamicSegments({ partnerId, customerCode, requests })
  }
}

export default SegmentsService
